import http from '../_http_v2';

const dashboard = {
  //date
  all: (m) => { return http.get(`console/webcastle/dashboard/all`, m); },
  month: (m) => { return http.get(`console/webcastle/dashboard/month`, m); },
  week: (m) => { return http.get(`console/webcastle/dashboard/week`, m); },
  day: (m) => { return http.get(`console/webcastle/dashboard/day`, m); },
  
  //install
  agent: (m) => { return http.get(`console/webcastle/dashboard/agent`, m); },

  //summary
  status: (m) => { return http.get(`console/webcastle/dashboard/status`, m); }
}

export default dashboard